
export enum enumDocumentLinkType {
  GoogleCloudStorage = 'GoogleCloudStorage', // a document stored within GoogleCloudStorage
  ExternalSource = 'ExternalSource', // a document hosted at an external source (SharePoint, Google Drive, etc.)
}
